import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";
const SUCCESE = async (data: any) => {
  toast.success(data, {
    position: toast.POSITION.TOP_LEFT,
  });
};
const FAILED = async (data: any) => {
  console.log(data);
  toast.error(data.message, {
    position: toast.POSITION.TOP_LEFT,
  });
};

export const EditAgreementMaster = createSlice({
  name: "EditAgreementMaster",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    data: [],
  },
  reducers: {
    edit_agreement_master: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_edit_agreement_master: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      // SUCCESE(action.payload.message);
    },
    failure_api_call_edit_agreement_master: (state, action) => {
      state.isLoading = false;
      state.api_completed = true;
      state.isSuccess = false;
      // FAILED(action.payload);
    },
    edit_agreement_isSuccess: (state, action) => {
      state.isSuccess = false;
    },
    edit_agreement_master_api_complete: (state, action) => {
      state.api_completed = false;
    },
  },
});
export default EditAgreementMaster.reducer;
export const {
  edit_agreement_master,
  success_api_call_edit_agreement_master,
  edit_agreement_isSuccess,
  edit_agreement_master_api_complete,
  failure_api_call_edit_agreement_master,
} = EditAgreementMaster.actions;
